<template>
    <div class="card col  px-0">
          <div class="card-header">
             <h4 class="card-title">Settings</h4>
          </div>
          <div class="card-body">
            <div class="row align-self-center">
              <div class="col-12 align-self-center">
                <div class="d-flex flex-row">
                  <div class="py-2 align-self-center"><p class="mb-0">Confirm deleting files </p></div>
                  <div class="py-2 ml-auto align-self-center">
                    <label @click="deleteConfirm()">
                      <bootstrap-toggle v-model="delete_confirm" :options="{ on: 'Yes', off: 'No' }" :disabled="false"  />
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-12  align-self-center">
                <div class="d-flex flex-row">
                  <div class="py-2 align-self-center"><p class="mb-0">Show Zip Download popup window </p></div>
                  <div class="py-2 ml-auto align-self-center">
                    <label @click="alwaysStart()">
                      <bootstrap-toggle v-model="show_zip" :options="{ on: 'Yes', off: 'No' }" :disabled="false"  />
                    </label>
                  </div>
                </div>    
              </div>
            </div>
          </div>
      </div>
</template>
<script>
  import BootstrapToggle from 'vue-bootstrap-toggle';
  export default {
    components: { BootstrapToggle },
    data() {
      return {
        delete_confirm: null,
        show_zip: true
      };
    },
    mounted() {
      if(localStorage.confirm_delete && (localStorage.confirm_delete == 'false' || localStorage.confirm_delete == false)){
        this.delete_confirm = false;
      } else {
        this.delete_confirm = true;
      }

      if(localStorage.always_start_download && (localStorage.always_start_download == 'false' || localStorage.always_start_download == false)){
        this.show_zip = true;
      } else if(!localStorage.always_start_download){
        this.show_zip = true;
      } else {
        this.show_zip = false;
      }
    },
    methods: {
      deleteConfirm(){
        if(this.delete_confirm == true ){
            localStorage.confirm_delete = false;
          } else {
            localStorage.confirm_delete = true;
          }
      },
      alwaysStart(){
        if(this.show_zip == true ){
            localStorage.always_start_download = true;
          } else {
            localStorage.always_start_download = false;
          }
      },
    }
  }
</script>
